var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShower = function SvgShower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.493,
    height: 51.319
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M25.301 0a13.21 13.21 0 0 0-13.17 12.451A13.21 13.21 0 0 0 0 25.6a1.02 1.02 0 0 0 1.02 1.022h24.341a1.02 1.02 0 0 0 1.022-1.022 13.21 13.21 0 0 0-12.2-13.155 11.147 11.147 0 0 1 22.269.747v36.627a1.023 1.023 0 1 0 2.045 0V13.192A13.207 13.207 0 0 0 25.301 0m-1.009 24.578h-22.2a11.148 11.148 0 0 1 22.2 0",
    "data-name": "Path 12"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M3.53 28.515a1.02 1.02 0 0 0-1.022 1.022v7.992a1.023 1.023 0 0 0 2.045 0v-7.994a1.02 1.02 0 0 0-1.023-1.02",
    "data-name": "Path 13"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M3.53 41.161a1.02 1.02 0 0 0-1.022 1.022v7.994a1.023 1.023 0 1 0 2.045 0v-7.994a1.02 1.02 0 0 0-1.023-1.022",
    "data-name": "Path 14"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M10.447 30.304a1.02 1.02 0 0 0-1.022 1.022v8.948a1.023 1.023 0 0 0 2.045 0v-8.948a1.02 1.02 0 0 0-1.023-1.022",
    "data-name": "Path 15"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M10.447 44.144a1.02 1.02 0 0 0-1.022 1.022v2.744a1.023 1.023 0 1 0 2.045 0v-2.744a1.02 1.02 0 0 0-1.023-1.022",
    "data-name": "Path 16"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M16.174 30.304a1.02 1.02 0 0 0-1.022 1.022v.954a1.023 1.023 0 0 0 2.045 0v-.954a1.02 1.02 0 0 0-1.023-1.022",
    "data-name": "Path 17"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M16.174 35.256a1.02 1.02 0 0 0-1.022 1.022v5.071a1.023 1.023 0 0 0 2.045 0v-5.071a1.02 1.02 0 0 0-1.023-1.022",
    "data-name": "Path 18"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M21.901 29.35a1.02 1.02 0 0 0-1.022 1.022v3.1a1.023 1.023 0 0 0 2.045 0v-3.1a1.02 1.02 0 0 0-1.023-1.022",
    "data-name": "Path 19"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "M21.901 37.343a1.02 1.02 0 0 0-1.022 1.022v11.931a1.023 1.023 0 1 0 2.045 0V38.365a1.02 1.02 0 0 0-1.023-1.022",
    "data-name": "Path 20"
  })))));
};
export default SvgShower;